export enum PlanFontFamily {
    bold = 'Roboto Bold',
    regular = 'Roboto Regular',
    cursive = 'Calligraffitti Regular',
}
